import { Box, FormControlLabel, FormControlLabelProps, Radio, Stack, Typography, styled, useTheme } from "@mui/material";
import { isString } from "lodash-es";
import React from "react";

const CustomIcon = styled("span")(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: "50%",
  boxSizing: "border-box",
  outline: "1px solid",
  outlineColor: theme.palette.dsSurface.v400,
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    opacity: 0.7,
  },
  "input:disabled ~ &": {
    opacity: 0.5,
  },
}));

const CustomCheckedIcon = styled(CustomIcon)(({ theme }) => ({
  backgroundColor: theme.palette.dsPrimary.v300,
  outline: "1px solid",
  outlineColor: theme.palette.dsPrimary.v300,
  borderRadius: "50%",
  border: "4px solid",
  borderColor: theme.palette.dsBase.v100,
  boxSizing: "border-box",
  "input:hover ~ &": {
    backgroundColor: theme.palette.dsPrimary.v400,
    opacity: 1,
  },
}));

interface IBybRadio {
  label: string | React.ReactNode;
  value?: unknown;
  icon?: React.ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  growLabel?: boolean;
}

const BybRadio = ({ label, value, icon, labelPlacement = "start", growLabel = false }: IBybRadio) => {
  const theme = useTheme();
  return (
    <FormControlLabel
      value={value}
      control={<Radio checkedIcon={<CustomCheckedIcon />} icon={<CustomIcon />} />}
      label={
        isString(label) ? (
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: "center",
            }}
          >
            {icon && (
              <Box
                sx={{
                  position: "relative",
                  height: theme.spacing(6),
                  width: theme.spacing(6),
                  borderRadius: "16px",
                  backgroundColor: theme.palette.dsSurface.v200,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: theme.palette.dsNeutral.v400,
                  }}
                >
                  {icon}
                </Box>
              </Box>
            )}
            <Typography variant="textBase400" color={theme.palette.dsBase.v200}>
              {label}
            </Typography>
          </Stack>
        ) : (
          label
        )
      }
      labelPlacement={labelPlacement}
      sx={{
        justifyContent: "space-between",
        ".MuiFormControlLabel-label": {
          flexGrow: growLabel ? 1 : undefined,
        },
        marginX: 0,
        marginY: theme.spacing(0.5),
      }}
    />
  );
};

export default BybRadio;
